<script setup lang="ts">
import type { PropType } from 'vue';

// PROPS
defineProps({
    appliedFilters: { type: Array as PropType<AppliedFilter[]>, required: true },
});
</script>

<template>
    <BaseDeletableBadge
        v-for="(filter, index) in appliedFilters"
        :key="index"
        color="primary"
        variant="soft"
        size="lg"
        :label="filter.label"
        @delete="filter.deleteHandler"
    />
</template>
